(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoTypeIbqDialogController', VideoTypeIbqDialogController);

    VideoTypeIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VideoType'];

    function VideoTypeIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VideoType) {
        var vm = this;

        vm.videoType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.videoType.id !== null) {
                VideoType.update(vm.videoType, onSaveSuccess, onSaveError);
            } else {
                VideoType.save(vm.videoType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:videoTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
